import React from 'react';

import { PageDetail } from 'components/blocks/Page';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <PageDetail />
    </div>
  );
};

export default DetailScreen;
